import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import Grid from "@material-ui/core/Grid";
import moment from "moment";

import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";

import { useStyles } from "./TeacherAssignmentDetails.css";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import UserHeader from "../../../../../Components/NavBar/User/UserHeader/UserHeader";
import PdfReader from "../../../../../Components/PDFReader/PdfReader";
import { publicImageUrl } from "../../../../../Config/publicImageUrl";
import { getUserRefreshToken } from "../../../../../Redux/Actions/actions";

class TeacherAssignmentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailData: {},
      files: [],
      pdfStatus: false,
      title: "",
      fileUrl: "",
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.getAssignmentDetails(this.props.match.params.id);
    }
  }

  getAssignmentDetails = async (assignmentId) => {
    try {
      const response = await Axios.get(
        `${url}/api/assignments/${assignmentId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.assignment) {
        this.setState({
          detailData: response.data.assignment,
          files: response.data.assignment.files,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getAssignmentDetails(assignmentId);
      }
    }
  };

  handlePdfStatus = (fileUrl, title) => {
    this.setState({
      pdfStatus: true,
      fileUrl,
      title,
    });
  };

  handleCancePdfStatus = () => {
    this.setState({
      pdfStatus: false,
    });
  };

  render() {
    const { classes } = this.props;
    const { detailData, files } = this.state;
    return (
      <div className={classes.root}>
        <UserHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <div style={{ fontSize: 24, fontWeight: "bold" }}>File Details</div>
          <div className={classes.listitemRoot}>
            <ListItem divider style={{ marginRight: 10 }}>
              <b style={{ flexGrow: 1 }}>Session</b>
              <div>{detailData.session}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Class</b>
              <div>{detailData.studentClass}</div>
            </ListItem>
          </div>
          <div className={classes.listitemRoot}>
            <ListItem divider style={{ marginRight: 10 }}>
              <b style={{ flexGrow: 1 }}>Faculty</b>
              <div>{detailData.faculty ? detailData.faculty : "N/A"}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Group</b>
              <div>{detailData.group ? detailData.group : "N/A"}</div>
            </ListItem>
          </div>
          <div className={classes.listitemRoot}>
            <ListItem divider style={{ marginRight: 10 }}>
              <b style={{ flexGrow: 1 }}>Title</b>
              <div>{detailData.title}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Subject</b>
              <div>{detailData.subject}</div>
            </ListItem>
          </div>
          <div className={classes.listitemRoot}>
            <ListItem divider style={{ marginRight: 10 }}>
              <b style={{ flexGrow: 1 }}>Submission Date</b>
              <div>{moment(files.submissionDate).format("LL")}</div>
            </ListItem>
            {files.length !== 0 && (
              <ListItem divider style={{ marginRight: 10 }}>
                <b style={{ flexGrow: 1 }}>Number of Assignment Files</b>
                <div>{files.length}</div>
              </ListItem>
            )}
          </div>
          {this.state.pdfStatus ? (
            <PdfReader
              fileUrl={this.state.fileUrl}
              title={this.state.title}
              handleCancelPdfStatus={this.handleCancelPdfStatus}
            />
          ) : (
            <Grid container spacing={3} className={classes.gridRoot}>
              {files.map((file, index) => (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={2}
                  xl={2}
                  lg={2}
                  key={index}
                  className={classes.gridContent}
                  onClick={() =>
                    this.handlePdfStatus(
                      `${publicImageUrl}/${file}`,
                      `${detailData.subject}-${detailData.title}-${index + 1}`
                    )
                  }
                >
                  <InsertDriveFileIcon style={{ width: 50, height: 50 }} />
                  <div>
                    {detailData.title} - {index + 1}
                  </div>
                </Grid>
              ))}
            </Grid>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(TeacherAssignmentDetails));
